import { getTransactionName, getTransactionReference } from '@peanuds/shared';

import type { ControlSpendingTableRow } from './control-spendings-table.adapter';
import type { ControlSpendingsTableFilter } from './control-spendings-table.types';

export type FilterableControlSpendingTableRow = ControlSpendingTableRow & {
  searchText: string;
};

export const buildControlSpendingSearchText = (row: ControlSpendingTableRow): string => {
  return [
    getTransactionName(row),
    getTransactionReference(row),
    row.narrative ?? '',
    row.transactionNumber ?? '',
    row.genericTransferType ?? '',
    row.status ?? '',
    row.dateAndTime ?? '',
    row.amount ?? '',
    row.currency ?? '',
    row.direction ?? '',
  ]
    .map((value) => value.toString())
    .join(' ')
    .toLowerCase();
};

export const appendControlSpendingSearchText = (
  row: ControlSpendingTableRow,
): FilterableControlSpendingTableRow => {
  return {
    ...row,
    searchText: buildControlSpendingSearchText(row),
  };
};

export const filterControlSpendingTableRows = (
  rows: readonly FilterableControlSpendingTableRow[],
  {
    filter,
    search,
  }: {
    filter: ControlSpendingsTableFilter;
    search: string;
  },
): FilterableControlSpendingTableRow[] => {
  const query = search.trim().toLowerCase();

  return rows.filter((row) => {
    if (filter === 'incoming' && row.direction !== 'in') return false;
    if (filter === 'outgoing' && row.direction !== 'out') return false;
    return query.length === 0 || row.searchText.includes(query);
  });
};
